import { Component, OnInit } from '@angular/core';
import { ThirdPartiesService } from '@services/third-parties.service';
import { ThirdPartiesAccount } from '@models/ThirdPartiesAccount';

@Component({
  selector: 'app-proceeding-details',
  templateUrl: './proceeding-details.component.html',
  styleUrls: ['./proceeding-details.component.scss']
})
export class ProceedingDetailsComponent implements OnInit {

  createOpentokFailures: ThirdPartiesAccount[] = null;
  connectAzureFailures: ThirdPartiesAccount[] = null;

  constructor(
    private thirdPartiesService: ThirdPartiesService
  ) { }

  ngOnInit() {
    this.thirdPartiesService.getThirdPartiesCreateOpentokFailures().subscribe(accounts => {
      this.createOpentokFailures = accounts;
    });
    this.thirdPartiesService.getThirdPartiesConnectAzureFailures().subscribe(accounts => {
      this.connectAzureFailures = accounts;
    });
  }

  onRetryCreateOpentokFailures() {
    this.thirdPartiesService.retryCreateOpentokFailures();
  }

  onRetryConnectAzureFailures() {
    this.thirdPartiesService.retryConnectAzureFailures();
  }

  onClearCreateOpentokFailures() {
    this.thirdPartiesService.clearCreateOpentokFailures();
  }

  onClearConnectAzureFailures() {
    this.thirdPartiesService.clearConnectAzureFailures();
  }
}
